/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Tbl from '@appblocks/codegeneration/Libraries/Tbl';
import TableItem from '@appblocks/codegeneration/SettingsConfigurations/TableItem';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const project: ProjectConfiguration = feature.project;
    const GROUPS = feature.getSettingValue('GROUPS');
    const dashboardEnabled = feature.getEnabled();
    const appVersion = project.getSettingValue('general', 'FIRMWAREVERSION');
    const TABLES = feature.getSettingValue('TABLES');
    const appID = project.id;

    if (!feature.getEnabled()) {
        return blocks;
    }

    let variableGetCode = '';
    let variableSetCode = '';
    const variablesGetCode = [];
    let cmdExecCode = '';
    const widgets = feature.getSettingValue('WIDGETS');
    const widgetsArray = [];
    const variableInCode: { [variable: string]: boolean } = {};
    blocks.push({
        location: 'DASHBOARD_SETUP_TITLE',
        blockType: BlockType.LOCATION,
        template: `
    "title": "${feature.getSettingValue('DASHBOARD_TITLE')}"`,
    });
    const projectVariables = project.getVariables();

    const variables = [];
    if (widgets.length > 0 && dashboardEnabled) {
        for (let i = 0; i < widgets.length; i++) {
            const widget = widgets[i].getWidgetObject();
            let { variable, linkType } = widget;
            try {
                const item = project.getFeature(variable);
                if (item?.id === 'variable') {
                    variable = item.getSettingValue('VARNAME');
                    let varValue = project.convertDataType(variable, item.getSettingValue('DATATYPE'), TibboDataType.STRING, '');
                    if (item.getSettingValue('DATATYPE') === TibboDataType.STRING) {
                        varValue = `"\\x22"+${varValue}+"\\x22"`;
                    }
                    linkType = 'variable';
                    if (!Object.prototype.hasOwnProperty
                        .call(variableInCode, variable)) {
                        variables.push(item);
                        variableInCode[variable] = true;
                    }
                } else if (item?.id === 'command') {
                    variable = item.getSettingValue('NAME');
                    linkType = 'command';
                    if (!Object.prototype.hasOwnProperty
                        .call(variableInCode, variable)) {
                        cmdExecCode += `
        case "${variable}":
            cmd_${variable}(value)`;
                        variableInCode[variable] = true;
                    }
                }
                widget.variable = variable;
                widget.linkType = linkType;
                widgetsArray.push(widget);
            } catch (ex) {
                widgets.splice(i, 1);
                i--;
            }
        }
    }

    //         for (let i = 0; i < widgets.length; i++) {
    //             const widget = widgets[i];
    //             if (widget.settings.customFn !== '') {
    //                 blocks.push({
    //                     location: 'DASHBOARD_CUSTOM_FN_DEF',
    //                     blockType: BlockType.LOCATION,
    //                     template: `
    // function custom${widget.id} (data) {
    //     ${widget.settings.customFn}
    // }`,
    //                 });
    //             }
    //         }

    for (let i = 0; i < TABLES.length; i++) {
        const tblItem = project.getFeature(TABLES[i].getSettingValue('TABLE')) as TableItem;
        if (!tblItem) {
            continue;
        }
        const tableJson = Tbl.getTableJson(tblItem);
        blocks.push({
            location: 'WEB_CONSOLE_TABLES',
            blockType: BlockType.CODE,
            template: `
            ${JSON.stringify(tableJson)},`,
        });
    }

    blocks.push({
        location: 'DASHBOARD_SETUP_WIDGETS',
        blockType: BlockType.CODE,
        template: `
        "updateInterval": ${feature.getSettingValue('INTERVAL') * 1000},
        "widgets": ${JSON.stringify(widgetsArray)},
        "widgetColumns": ${feature.getSettingValue('WEB_ADMIN_WIDGET_COLUMNS')},`,
    });


    blocks.push({
        location: 'DASHBOARD_APP_VERSION',
        blockType: BlockType.CODE,
        template: `
        "appName": "${project.name}",
        "appVersion": "${appVersion}",
        "appId": "${appID}",
        `,
    });

    const settingGroups = feature.getSettingValue('GROUPS');

    for (let i = 0; i < settingGroups.length; i += 1) {
        const group = settingGroups[i];
        const settings = group.getSettingValue('SETTINGS');
        for (let j = 0; j < settings.length; j += 1) {
            const setting = settings[j];
            const settingItem = project.getFeature(setting.getSettingValue('SETTINGID'));
            if (!settingItem) {
                continue;
            }
            const variable = projectVariables.find((v: any) => v.getSettingValue('FEATURE') === settingItem.getSettingValue('ID'));
            if (!variable) {
                continue;
            }
            if (!Object.prototype.hasOwnProperty
                .call(variableInCode, variable.getSettingValue('VARNAME'))) {
                variables.push(variable);
                variableInCode[variable.getSettingValue('VARNAME')] = true;
            }
        }
    }

    for (let i = 0; i < variables.length; i += 1) {
        const variable = variables[i];
        const VARNAME = variable.getSettingValue('VARNAME');
        let varValue = project.convertDataType(VARNAME, variable.getSettingValue('DATATYPE'), TibboDataType.STRING, '');
        if (variable.getSettingValue('DATATYPE') === TibboDataType.STRING) {
            varValue = `"\\x22"+${varValue}+"\\x22"`;
        }

        variableGetCode += `
        case "${VARNAME}":
            var_value= ${varValue}`;
        variableSetCode += `
        case "${VARNAME}":
            var_${VARNAME}_set(${project.convertDataType('value', TibboDataType.STRING, variable.getSettingValue('DATATYPE'))})`;
        variablesGetCode.push(`value = "\\x22${VARNAME}\\x22:" + ${varValue}`);
        if (i < variables.length - 1) {
            variablesGetCode.push('value = value + ","');
        }
        variablesGetCode.push(`
if sock.txfree<len(value) then
    send_timeout=sys.timercountms+2000
    sock.send()
    while (sock.txlen>0) AND sys.timercountms<send_timeout
    wend
end if
sock.setdata(value)
`);
    }

    for (let i = 0; i < variablesGetCode.length; i++) {
        blocks.push({
            location: 'HTTP_VARIABLES_VALUE_GET',
            blockType: BlockType.CODE,
            template: `
            ${variablesGetCode[i]}`,
        });
    }


    blocks.push({
        location: 'HTTP_VARIABLE_VALUE_GET',
        blockType: BlockType.CODE,
        template: `
dim var_value as string = ""
select case variable
    ${variableGetCode}
    case else:
end select
sock.setdata(var_value)
sock.send()`,
    });


    blocks.push({
        location: 'HTTP_VARIABLE_VALUE_SET',
        blockType: BlockType.CODE,
        template: `
select case variable
    ${variableSetCode}
    case else:
end select`,
    });

    for (let i = 0; i < GROUPS.length; i++) {
        const group = GROUPS[i];
        if (group.getSettingValue('SETTINGS').length > 0) {
            blocks.push({
                location: 'HTTP_CMD_SETTINGS',
                blockType: BlockType.CODE,
                template: `
dim result as string
dim x,y as byte
const LUIS_MAX_CMD_LEN = STG_MAX_SETTING_VALUE_LEN + STG_MAX_SETTING_NAME_LEN + 3
dim http_cmd_str as string(LUIS_MAX_CMD_LEN)
result = stgcmd_proc_cmd(cmd_str)
if result<>"" then
    sock.setdata(result)
    sock.send()
end if`,
            });
            break;
        }
    }


    blocks.push({
        location: 'HTTP_CMD_TRIGGER',
        blockType: BlockType.CODE,
        template: `
select case variable
    ${cmdExecCode}
    case else:
end select`,
    });

    blocks.push({
        location: 'luis_variable_get',
        blockType: BlockType.CODE,
        template: `
sub luis_variable_get(byref name as string) as string

end sub`,
    });

    if (project.device.deviceType === 'TPP') {
        blocks.push({
            location: 'HOMEPAGE_INFORMATION',
            blockType: BlockType.CODE,
            template: `
        #IF PLATFORM_ID=WM2000 OR PLATFORM_ID=WS1102
        sock.setdata("\\x22ip\\x22:\\x22" + wln.ip + "\\x22,")
        sock.setdata("\\x22mac\\x22:\\x22" + hex_mac(wln.mac) + "\\x22,")        
        #ELSE  
        sock.setdata("\\x22ip\\x22:\\x22" + net.ip + "\\x22,")
        sock.setdata("\\x22mac\\x22:\\x22" + hex_mac(net.mac) + "\\x22,")
        #ENDIF
        sock.setdata("\\x22wlnmac\\x22:\\x22" + hex_mac(wln.mac) + "\\x22,")
        sock.setdata("\\x22wlnip\\x22:\\x22" + wln.ip + "\\x22,")`,
        });
    }

    // password
    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
http_server_password = ${feature.getSettingValue('PASSWORD')}`,
    });

    blocks.push({
        location: 'Main.js',
        blockType: BlockType.CODE,
        template: `
'****RUN_COMMAND_FUNCTION****'
'****DASHBOARD_MAIN_FILE****'`,
    });

    // front end widgets template
    if (!process.env.BROWSER) {
        // eslint-disable-next-line global-require
        const fs = require('fs');
        // eslint-disable-next-line global-require
        const path = require('path');
        let pathRoot = (globalThis as any).appRoot;
        if (pathRoot === undefined) {
            pathRoot = path.join(__dirname, '..', '..', 'frontend');
        } else {
            pathRoot = path.join(pathRoot, 'frontend');
        }
    }

    let settingsCode = '';
    for (let i = 0; i < GROUPS.length; i++) {
        const tmpBlocks = GROUPS[i].getCodeBlocks();
        for (let j = 0; j < tmpBlocks.length; j++) {
            if (tmpBlocks[j].location === 'LUIS_GROUP_ITEM') {
                settingsCode += tmpBlocks[j].template;
                if (i + 1 < GROUPS.length) {
                    settingsCode += ',';
                }
            }
        }
    }
    blocks.push({
        location: 'DASHBOARD_SETTINGS_SCHEMA',
        template: settingsCode,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        template: `
#IFDEF TBL_MAX_NUM_TABLES
declare sub tables_web_proc_sock_data_sent()
#ENDIF
        `,
    });

    blocks.push({
        location: 'on_sock_data_sent',
        template: `
#IFDEF TBL_MAX_NUM_TABLES
tables_web_proc_sock_data_sent()
#ENDIF`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        template: `
#IFDEF TBL_MAX_NUM_TABLES
sub tables_web_proc_sock_data_sent()
    dim index as byte=http_server_get(sock.num)
    if index<>255 then
        if http_servers(index).state=HTTP_SERVER_STATE_RS_BODY_CONTENT then
            dim server as http_server_state=http_servers(index)
            'for returning table rows
            dim tbl_rows, tbl_rows_all as word
            dim i as word
            dim j, num_of_fld as byte
            dim tmp_data as string=server.request_path
            dim is_json as boolean=instr(1,server.request_file_name,"api/tables",1)>=1
            if server.request_method<>"GET" then
                tmp_data=server.request_value_buffer
            end if
            dim table_name as string=http_server_find_param(tmp_data,"table")
            tbl_web_get_table_active_rows(table_name, tbl_rows, tbl_rows_all)
            num_of_fld = tbl_get_num_fields(table_name)
            dim row_num as word=server.request_read_pos
            tbl_record_read_active(row_num)
            dim count as word=val(http_server_find_param(tmp_data,"count"))
            dim offset as word=val(http_server_find_param(tmp_data,"offset")) + 1
            tmp_data=""
            if row_num<server.request_read_pos then
                http_servers(index).state=HTTP_SERVER_STATE_RS_BODY
                tbl_close(table_name)
                if is_json then
                    sock.setdata("]")
                    sock.send()
                end if
                sock.notifysent(0)
                exit sub
            end if
            if count=0 then
                'return all rows
                if is_json then
                    tmp_data=tbl_web_get_fld_data_json(row_num, num_of_fld)
                    if row_num<tbl_rows then
                        tmp_data=tmp_data+","
                    end if
                else
                    tmp_data=tbl_web_get_fld_data(row_num, num_of_fld)+"\\r\\n"
                end if
                sock.setdata(tmp_data)
                sock.send()
            else
                if row_num < (offset + count) then
                    if is_json then
                        tmp_data=tbl_web_get_fld_data_json(row_num, num_of_fld)
                        if row_num<=tbl_rows then
                            tmp_data=tmp_data+","
                        end if
                    else
                        tmp_data=tbl_web_get_fld_data(row_num, num_of_fld)+"\\r\\n"
                    end if
                    sock.setdata(tmp_data)
                    sock.send()
                end if
            end if
            http_servers(index).request_read_pos=row_num+1
            sock.notifysent(sock.txbuffsize-len(tmp_data))
            
        end if
    end if
end sub
#ENDIF`,
    });

    blocks.push({
        location: 'callback_http_server_endpoint_called',
        template: `

dim params as string=server.request_path
dim value as string=""

if server.request_method<>"GET" then
    params=server.request_value_buffer
end if
dim loggedin as boolean=server.request_authenticated        

if server.request_file_name="api.html" then
    callback_http_server_endpoint_called=true
    dim result as string=""
    dim endpoint as string(3)=http_server_find_param(params, "e")
    dim action as string(20)=http_server_find_param(params, "action")
    dim loggedin as boolean=server.request_authenticated

    if endpoint="a" AND action="get" then 'authentication challenge
        http_server_response_status(200)
        http_server_response_header("Content-Type", "text/plain")
        http_server_response_header_end()
        sock.setdata("0")
        sock.send()
    else
    
    
    if loggedin then

    http_server_response_status(200)
    http_server_response_header("Content-Type", "application/json")
    http_server_response_header("Access-Control-Allow-Origin", "*")
    http_server_response_header("Connection", "close")

    http_server_response_header_end()

    select case endpoint
        case "i": 'information
            select case action
                case "get":
                    dim firmwareVersion as string(40)=mid(sys.version, 2,len(sys.version) - 2)
                    dim timestamp as dword=datetime_current_timestamp()
                    dim daycount, mincount as word
                    dim seconds as byte
                    datetime_from_timestamp(timestamp, daycount, mincount, seconds)
                    rtc.getdata(daycount, mincount, seconds)
                    sock.setdata("{")
                    sock.setdata("\\x22firmwareVersion\\x22:\\x22" + firmwareVersion + "\\x22,")
                    '****HOMEPAGE_INFORMATION****'
                    sock.setdata("\\x22bootTime\\x22:\\x22" + lstr(timestamp - sys.timercount32 / 2)  + "\\x22,")
                    #IF WLN_AVAILABLE=1
                    sock.setdata("\\x22wifiOn\\x22:\\x22" + str(wln.enabled) + "\\x22,")
                    #ELSE
                    sock.setdata("\\x22wifiOn\\x22:\\x22false\\x22,")
                    #ENDIF
                    sock.setdata("\\x22timezone\\x22:\\x22" + str(APP_TIMEZONE) + "\\x22,")
                    sock.setdata("\\x22time\\x22:\\x22" + lstr(timestamp) + "\\x22" )
                    sock.setdata("}")
                    sock.send()
                case "edit_t":
                    dim timestamp as dword=http_server_find_param(params, "t")
                    dim days, minutes as word
                    dim secs as byte
                    datetime_from_timestamp(timestamp, days, minutes, secs)
                    td_gmt_to_local(days, minutes, datetime_tz_offset, PL_OFF)
                    rtc.setdata(days, minutes, secs)
                    sock.setdata("\\x22time\\x22:\\x22" + lstr(timestamp) + "\\x22")
                    sock.send()
                case "get_tz":
                    sock.setdata(str(APP_TIMEZONE))
                    sock.send()
                case "edit_tz":
                    dim timestamp as dword=http_server_find_param(params, "t")
                    dim days, minutes as word
                    dim secs as byte
                    dim new_tz_offset as en_td_timezones=http_server_find_param(params, "tz")
                    datetime_tz_offset= new_tz_offset
                    APP_TIMEZONE = new_tz_offset
                    datetime_from_timestamp(timestamp, days, minutes, secs)
                    td_gmt_to_local(days, minutes, new_tz_offset, PL_OFF)
                    rtc.setdata(days, minutes, secs)
                    sock.setdata("{")
                    sock.setdata("\\x22timezone_offset\\x22:\\x22" + str(APP_TIMEZONE) + "\\x22")
                    sock.setdata("\\x22time\\x22:\\x22" + lstr(timestamp) + "\\x22")
                    sock.setdata("}")
                    sock.send()
                case else :

            end select

        case "v": 'variable
            dim variable as string=http_server_find_param(params, "variable")
            action=http_server_find_param(params, "action")
            value=http_server_decode(http_server_find_param(params, "value"))
            if action="get" then
            '****HTTP_VARIABLE_VALUE_GET****'
            else if action="set" then
            '****HTTP_VARIABLE_VALUE_SET****'
            end if
        case "w":
            action=http_server_find_param(params, "a")
            if action="get" then
                dim send_timeout as dword=sys.timercountms+2000
                sock.setdata("{")
                '****HTTP_VARIABLES_VALUE_GET****'
                sock.setdata("}")
                sock.send()
                send_timeout=sys.timercountms+2000
                while (sock.txlen>0) AND sys.timercountms<send_timeout
                wend
            end if
        case "s": 'Settings / LUIS
            action=http_server_find_param(params, "a")
            select case action
            case "def": 'settings.xtxt and sdf.xtxt

            case "set": 'set value

            case "get": 'get value

            case "cmd": 'send command
                dim cmd_str as string=http_server_decode(http_server_find_param(params, "cmd"))
                dim x,y as byte
                result = stgcmd_proc_cmd(cmd_str)
                if result<>"" then
                    sock.setdata(result)
                    sock.send()
                end if
            case else:

            end select

        case "t": 'tables
        #IFDEF TBL_MAX_NUM_TABLES
            action=http_server_find_param(params,"a")
            dim table_name as string(TBL_MAX_TABLE_NAME_LEN)
            dim index as byte=0
            dim row as string=""
            select case action
            case "get":
                dim table_type as string=http_server_find_param(params, "type")
                tbl_web_get_tables(table_type)
            case "count":
                table_name=http_server_find_param(params,"table")
                dim tbl_rows as word=0
                dim tbl_rows_all as word=0
                tbl_web_get_table_active_rows(table_name, tbl_rows, tbl_rows_all)
                sock.setdata(str(tbl_rows))
                sock.send()
            case "rows":
                server.state=HTTP_SERVER_STATE_RS_BODY_CONTENT
                table_name=http_server_find_param(params,"table")
                dim offset as word=val(http_server_find_param(params,"offset")) + 1
                if offset=0 then
                    offset=1
                end if
                server.request_read_pos=offset
                result=tbl_web_get_header(table_name)+"\\r\\n"
                sock.notifysent(sock.txbuffsize-255)
            case "add":
                table_name=http_server_find_param(params,"table")
                row=http_server_decode(http_server_find_param(params,"row"))
                result=tbl_web_add_row(table_name,row)
            case "delete":
                table_name=http_server_find_param(params,"table")
                dim row_index as word=val(http_server_decode(http_server_find_param(params,"row")))
                tbl_web_delete_row(table_name,row_index)
            case "clear":
                table_name=http_server_find_param(params,"table")
                result=tbl_web_clear_table(table_name)
            case "edit":
                table_name=http_server_find_param(params,"table")
                row=http_server_decode(http_server_find_param(params,"row"))
                dim index as word=val(http_server_find_param(params,"index"))
                result=tbl_web_edit_row(table_name,index,row)
            case "get_field_default":
                table_name=http_server_find_param(params,"table")
                dim field_name as string=http_server_find_param(params,"field_name")
                result=http_server_find_param(table_name,field_name)
            case else:
                result="Unsupported Action"
            end select
            sock.setdata(result)
            sock.send()
        #ENDIF

        case "f": 'RPC functions
            dim variable as string=http_server_decode(http_server_find_param(params,"variable"))
            value=http_server_decode(http_server_find_param(params,"value"))
            '****HTTP_CMD_TRIGGER****'
        case else:
    end select
    else
        http_server_response_status(401)
        http_server_response_header("WWW-Authenticate", "basic")

        http_server_response_header_end()
        sock.setdata("\\x02UNAUTHORIZED\\x02")
        sock.send()
    end if
    end if
else if instr(1,server.request_file_name,"api/tables",1)>=1 then
        if loggedin then
            callback_http_server_endpoint_called=true
            server.state=HTTP_SERVER_STATE_RS_BODY_CONTENT
            dim table_name as string=http_server_find_param(params,"table")
            dim offset as word=val(http_server_find_param(params,"offset")) + 1
            if offset=0 then
                offset=1
            end if
            server.request_read_pos=offset
#IFDEF TBL_MAX_NUM_TABLES
            if tbl_select(table_name, table_name)<>EN_TBL_STATUS_OK then
                http_server_response_status(500)
                http_server_response_header("Content-Type", "application/json")
                http_server_response_header("Access-Control-Allow-Origin", "*")
                http_server_response_header("Connection", "close")
                http_server_response_header_end()
                server.state=HTTP_SERVER_STATE_END
            else
            tbl_web_get_flds(table_name)

                http_server_response_status(200)
                http_server_response_header("Content-Type", "application/json")
                http_server_response_header("Access-Control-Allow-Origin", "*")
                http_server_response_header("Connection", "close")
                http_server_response_header_end()
                sock.setdata("[")
                sock.send()
                sock.notifysent(sock.txbuffsize-255)
            end if
#ELSE
            http_server_response_status(500)
            http_server_response_header("Content-Type", "application/json")
            http_server_response_header("Access-Control-Allow-Origin", "*")
            http_server_response_header("Connection", "close")
            http_server_response_header_end()
            server.state=HTTP_SERVER_STATE_END
#ENDIF
        else
            http_server_response_status(401)
            http_server_response_header("WWW-Authenticate", "basic")
    
            http_server_response_header_end()
            sock.setdata("\\x02UNAUTHORIZED\\x02")
            sock.send()
        end if
else
    callback_http_server_endpoint_called=false
end if
        `,
    });

    return blocks;
};
